import { render } from "./block-ip.vue?vue&type=template&id=1569491e&scoped=true"
import script from "./block-ip.vue?vue&type=script&lang=js"
export * from "./block-ip.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./block-ip.vue?vue&type=style&index=1&id=1569491e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1569491e"]])

export default __exports__